const MerchandiseRack = {

    // FIELDS
    "customer": "العميل",
    "rack": "الرف",
    "name": "الاسم",
    "search": "بحث",

    // PAGE HEADER
    "merchant_rack": "رف البضائع",

    // ERROR
    "error_customer": "اختر العميل",
    "error_name": "أدخل الاسم",

    // TABLE HEADER
    "table_customer": "العميل",
    "table_grade": "الدرجة",
    "table_type": "النوع",
    "table_city": "المدينة",
    "table_category": "الفئة",
}

export default MerchandiseRack;